import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";

import { ME_QUERY } from "graphql/me/queries";
import useIdentity from "hooks/useIdentity";
import { Identity, Me } from "types/User";

type AuthUser = Me & { uid: string };

type Auth = {
  loading: boolean;
  user: AuthUser | Identity;
  isLoggedIn: boolean;
};

export default function useAuth(): Auth {
  const jwtIdentity = useIdentity();
  const { loading: loadingMe, data } = useQuery(ME_QUERY);
  const [user, setUser] = useState<AuthUser | undefined>();

  const isLoggedIn = !!user;

  useEffect(() => {
    if (!loadingMe && data) {
      setUser({ ...data.me, uid: data.me.id });
    }
  }, [data, loadingMe]);

  // loadingMe will intially be undefined if the user is not authenticated since the useQuery
  // hook will not be running. If the user is initially authenticated loadingMe will be a
  // boolean starting as true since the useQuery hook will be running.
  return {
    loading: loadingMe,
    user: user || jwtIdentity,
    isLoggedIn,
  };
}
